import i18next from 'i18next'
import detector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import {
    de,
    en,
    en_us,
    es,
    fr,
    it,
    ja,
    ko,
    pt,
    zh_hans,
    zh_hant,
} from './locales'

const i18n = i18next.createInstance()
let isInitialized = false

const storedLanguage =
    localStorage.getItem('selectedLanguage') ??
    localStorage.getItem('i18nextLng') ??
    undefined

export const initializeI18n = async () => {
    if (isInitialized) {
        return i18n
    }

    await i18n
        .use(HttpBackend)
        .use(detector)
        .init({
            debug: true,
            fallbackLng: 'en-GB',
            lng: storedLanguage,
            defaultNS: 'translation',
            detection: {
                order: [
                    'localStorage',
                    'navigator',
                    'htmlTag',
                    'path',
                    'subdomain',
                ],
                caches: ['localStorage'],
                lookupQuerystring: 'lng',
            },
            backend: {
                loadPath: '/messages/{{lng}}.json',
            },
        })

    /// Needs to match file names and what a browser might say the language is, therefore we have en, en-GB, en-US ect...
    i18n.addResourceBundle('en', 'translation', en)
    i18n.addResourceBundle('en-GB', 'translation', en)
    i18n.addResourceBundle('en-US', 'translation', en_us)
    i18n.addResourceBundle('fr', 'translation', fr)
    i18n.addResourceBundle('es', 'translation', es)
    i18n.addResourceBundle('es-ES', 'translation', es)
    i18n.addResourceBundle('it', 'translation', it)
    i18n.addResourceBundle('pt', 'translation', pt)
    i18n.addResourceBundle('de', 'translation', de)
    i18n.addResourceBundle('de-DE', 'translation', de)
    i18n.addResourceBundle('ko', 'translation', ko)
    i18n.addResourceBundle('ja', 'translation', ja)
    i18n.addResourceBundle('zh', 'translation', zh_hans)
    i18n.addResourceBundle('zh-CN', 'translation', zh_hans)
    i18n.addResourceBundle('zh-TW', 'translation', zh_hant)

    isInitialized = true

    return i18n
}

export default i18n
